module.exports = __webpack_public_path__ + "img/me-time.4abc17c7.svg";